import React, {useEffect} from "react";
import Table from "../../components/Table";
import Item from "./Item";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List, Map} from "immutable";
import {graphql} from "react-apollo";
import PaginatorButton from "../../components/PaginatorButton";
import withFiltersAndSorting, {SORTING_DIRECTIONS} from "../../lib/WithFiltersAndSorting";
import {CONSIGNMENTS} from "../../queries/warehouseTracking";


// The system has no idea when the hallstein label system will have fresh data
// TODO: the system is pulling data from at an interval so we should use that
// and subscribe to those updates here.
const TEMP_TIMER_FOR_DATA_REFRESH = 3000;


function ConsignmentList(props) {
  const {
    loading, error, refetch,
    consignments = [],
  } = props.data;

  useEffect(() => {
    const timerId = window.setInterval(refetch, TEMP_TIMER_FOR_DATA_REFRESH);

    return () => window.clearInterval(timerId);
  }, []);

  useEffect(() => {
    // Fake clicking whenever the list gets updated to force refreshing the
    // side view
    if (props.selectedId) {
      handleItemClick(Map({consignmentId: props.selectedId}));
    }
  }, [consignments]);
  
  if (error) return <GraphQLErrors error={error} />
  
  // While content is loading we set data as empty array
  const data = fromJS(consignments);
  const tableData = data.get("entries")
    ? data.get("entries").map((entry) => entry.get("consignment").set("activitiesStatus", entry.getIn(["consignmentActivities", "status"])))
    : List();

  function handleItemClick(itemData, e) {
    const id = itemData.get("consignmentId");
    const consignmentAndActivities = data.get("entries").find((entry) => entry.getIn(["consignment", "consignmentId"]) === id);

    if (e?.target?.classList?.contains("f-open-details")) {
      props.onDetailsCommand(consignmentAndActivities);
    } else {
      props.onSelectionChange(id, consignmentAndActivities);
    }
  }
  function handleNext(afterId) {
    props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          consignments: {
            __typename: prev.consignments.__typename,
            metadata: fetchMoreResult.consignments.metadata,
            entries: [...prev.consignments.entries, ...fetchMoreResult.consignments.entries]
          }
        }
      },
    });
  }

  return (
    <div>
      <Table
        loading={loading}
        data={tableData}
        renderer={Item}
        tableHeader={props.tableColumns}
        createFilteringInput={props.createFilteringInput}
        createSortingArrows={props.createSortingArrows}
        mode="table"
        onItemClick={handleItemClick}
        itemKey="consignmentId"
        showCount={true}
        selected={props.selectedId}
        />
      <PaginatorButton
        metadata={data.get("metadata")}
        onNext={handleNext}
        />
    </div>
  );
}


const withQuery = graphql(CONSIGNMENTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      warehouseId: props.warehouseId,
      filter: {
        ...props.filters,
        statusFilter: props.statusFilter,
        temporalFilter: props.temporalFilter,
      },
      sortOrders: props.sortOrders,
    },
  })
});

const withGraphQL = withQuery(ConsignmentList);

export default withFiltersAndSorting(withGraphQL, {
  tableColumns: (_props) => [
    { title: "Id" },
    { title: "External Order Id" },
    { title: "Recipient" },
    { title: "Postcode" },
    { title: "Status" },
    { title: "Updated" },
  ],
  defaultSortings: [
    {name: "updatedAt", direction: SORTING_DIRECTIONS.DESC},
  ]
});
